var myProductGlobalObj = {
    id: null,
    variantId: null,
    curProductDCnfo: null,
    curVariantDiscountInfo: null,
    currency: "US$",
};

// 页面初始化
document.addEventListener("DOMContentLoaded", ()=>{
    myInitData();
    myGetCurrentVariantId();
    myOnVariantSubscribe();
    myInitDiscountConfig();

    myProductVariantSetPresaleFn();
});
function myInitData() {
    // 获取当前的产品id
    myProductGlobalObj.id = window.myProductId || null;
    myProductGlobalObj.variantId = window.myCurVaraintId || null;
}
// 获取当前的变体id
function myGetCurrentVariantId() {
    if (!myProductGlobalObj.variantId) {
        // 如果全局对象中没有变体id，可以尝试从页面路由获取 variant= 后面的值
        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromUrl = urlParams.get('variant');
        if (variantIdFromUrl) {
            myProductGlobalObj.variantId = variantIdFromUrl;
        } else {
            console.warn("无法获取当前变体ID");
        }
    }
}

// 订阅变体的变化
function myOnVariantSubscribe() {
    subscribe(
        PUB_SUB_EVENTS.variantChange,
        (data) => {
            const variantId = data?.data?.variant?.id;
            if (variantId) myOnVariantChange(String(variantId));
        }
    );
}
// 监听来自 变体id的变化
function myOnVariantChange(newVariantId) {
    console.log("变体变化了", newVariantId);
    if(newVariantId !== myProductGlobalObj.variantId) {
        myProductGlobalObj.variantId = newVariantId;

        MyCustomProductSliderConstructor?.myProdSliderVariantForImg(newVariantId)
        // 每次变体变化时，获取当前的折扣信息
        myGetCurrentDiscountInfo();
        myProductVariantSetPresaleFn();
    }
}

// 产品折扣相关的代码
// 初始化获取折扣的配置
var myProductDCConfigObj = {
    bannerEle: null,
    copyBtnEle: null,
    numberWrapEle: null,
    codeWrapEle: null,

}
function myInitDiscountConfig() {
    // 这里可以根据需要从全局对象或者其他地方获取折扣配置
    // 例如：myProductGlobalObj.discountConfig = ...
    console.log("初始化折扣配置", window.myCustomProdDCConfigObj);
    myProductGlobalObj.curProductDCnfo = window.myCustomProdDCConfigObj[myProductGlobalObj.id] || null;
    myGetCurrentDiscountInfo();
}

// 获取当前变体的折扣信息
function myGetCurrentDiscountInfo() {
    if (myProductGlobalObj.curProductDCnfo) {
        myProductGlobalObj.curVariantDiscountInfo = myProductGlobalObj.curProductDCnfo[myProductGlobalObj.variantId] || null;
    }
    console.log("当前变体的折扣信息", myProductGlobalObj.curVariantDiscountInfo);
    // 更新折扣信息到页面
    if (!myProductDCConfigObj.bannerEle) {
        myProductDCConfigObj.bannerEle = document.getElementById("myProductDiscountBannerWrapId");
    }
    if (!myProductDCConfigObj.numberWrapEle) {
        myProductDCConfigObj.numberWrapEle = document.getElementById("myProductNewBannerNumId");
    }
    if (!myProductDCConfigObj.codeWrapEle) {
        myProductDCConfigObj.codeWrapEle = document.getElementById("myProductNewBannerCodeId");
    }
    if(!myProductDCConfigObj.descWrapEle) {
        myProductDCConfigObj.descWrapEle = document.getElementById("myProductBannerDescCWrapId");
    }
    
    if (myProductGlobalObj.curVariantDiscountInfo) {
        // 显示折扣信息
        myProductDCConfigObj.bannerEle.style.display = "block";
        myProductDCConfigObj.numberWrapEle.innerText = myProductGlobalObj.curVariantDiscountInfo.disCountoff || "";
        myProductDCConfigObj.codeWrapEle.innerText = myProductGlobalObj.curVariantDiscountInfo.disCountcode || "";
        myProductDCConfigObj.descWrapEle.innerText = myProductGlobalObj.curVariantDiscountInfo.desc || "";
    } else {
        // 隐藏折扣信息
        myProductDCConfigObj.bannerEle.style.display = "none";
    }
}
async function myOnCopyDiscountCode() {
    if (!myProductGlobalObj.curVariantDiscountInfo || !myProductGlobalObj.curVariantDiscountInfo.disCountcode) {
        return
    }
    if (myProductGlobalObj.curVariantDiscountInfo && myProductGlobalObj.curVariantDiscountInfo.disCountcode) {
        const code = myProductGlobalObj.curVariantDiscountInfo.disCountcode;
        const spanEl = document.getElementById('myProductNewBannerCopySpanId');
        let flag = await myCopyToClipboard(code);
        if (flag) {
            if (spanEl) {
              spanEl.textContent = 'copied!';
              setTimeout(function () { spanEl.textContent = 'Copy Code'; }, 2000);
            }
        } else {
            console.error("复制折扣码失败");
        }
    }
}
// 产品折扣相关的代码 ---end

// 产品描述相关代码
function myCustomProdDescItemClick(dom) {
    var contentEl = dom.parentElement.querySelector('.my-custom-prod-desc-item-cont');
    var svgEl = dom.querySelector('.my-custom-prod-desc-item-svg');

    if (contentEl.classList.contains('custom-prod-desc-item-cont-show')) {
      dom.classList.remove('custom-prod-desc-item-title-active');
      contentEl.classList.remove('custom-prod-desc-item-cont-show');
      if (svgEl) svgEl.classList.remove('custom-prod-desc-item-svg-up');
    } else {
      dom.classList.add('custom-prod-desc-item-title-active');
      contentEl.classList.add('custom-prod-desc-item-cont-show');
      if (svgEl) svgEl.classList.add('custom-prod-desc-item-svg-up');
    }
}
// 产品描述相关代码 ---end

// 产品预售描述的相关代码
function myProductVariantSetPresaleFn(){
    console.log("设置预售描述");
    if (myProductGlobalObj.variantId && myCustomPresaleDescConfig[myProductGlobalObj.variantId]) {
        document.getElementById("myCustomProductPresaleDescId").innerText = myCustomPresaleDescConfig[myProductGlobalObj.variantId];
    }
}
// 产品预售描述的相关代码 ---end

// 移动端查看大图的功能
function myCustomProdOptionViewBigImgFn (){
    let index = MyCustomProductSliderConstructor?.currentIndex || 0;
    MyCustomProductSliderConstructor.imgScreenSeeIndex = index;
    $('.my-custom-img-screen-see-wrap').removeClass('noshow');
    MyCustomProductSliderConstructor.updateSeeScreenImgFn();
}

// 变体加购的函数
function myVariantAddToCart() {

}


// 悬浮购物车功能

// 悬浮购物车功能 ---end


// 工具函数

// 金额转换

// 复制功能
async function myCopyToClipboard(text) {
    let flag = false;
    if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text).then(function () {
            flag = true;
        }).catch(function (err) {
            console.error('Async: Could not copy text: ', err);
        });
    } else {
        // Fallback
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;left:-9999px;';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        flag = true;
    }
    return flag;
}
// 工具函数 ---end
